import { useState, useEffect } from 'react';
import { Router } from '../routes';
import REDIRECT_TIMEOUT from './redirectTimeout';

const useRedirectOnSignupSuccess = () => {
  const signupState = useState(false);
  const [success] = signupState;

  useEffect(() => {
    if (success) {
      setTimeout(() => Router.pushRoute('login'), REDIRECT_TIMEOUT);
    }
  }, [success]);
  return signupState;
};

export default useRedirectOnSignupSuccess;
